export default __webpack_public_path__ + "images/0xea38f1ccf77bf43f352636241b05dd8f6f5f52b2.png";